export default __webpack_public_path__ + "static/media/marketing.f0b938cb.svg";